import { GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import Tracking from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
export default {
    name: 'BoardAddNewColumnBetween',
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        Tracking.mixin()
    ],
    emits: [
        'set-add-column-form-visibility'
    ],
    methods: {
        handleClick () {
            this.$emit('set-add-column-form-visibility', true);
            this.track('click_button', {
                label: 'create_list'
            });
        }
    }
};
